
import { styled } from '@mui/material/styles';
import { Box, Table, TableCell, TableContainer, TableHead, TableRow, Typography, Select, TextField, Button, Chip } from '@mui/material';

export const TableWrapper = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(3),
  backgroundColor: '#fff',
  borderRadius: '8px',
  boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.05)',
  padding: theme.spacing(3),
  width: '100%',
}));

export const FilterContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginBottom: theme.spacing(3),
  flexWrap: 'wrap',
  gap: theme.spacing(2),
}));

export const SearchField = styled(TextField)(({ theme }) => ({
  width: '350px',
  '& .MuiOutlinedInput-root': {
    borderRadius: '8px',
    backgroundColor: '#fff',
    height: '40px',
  },
  '& .MuiOutlinedInput-input': {
    padding: '8px 14px',
  }
}));

export const FilterSelect = styled(Select)(({ theme }) => ({
  height: '40px',
  borderRadius: '8px',
  minWidth: '150px',
  backgroundColor: '#fff',
}));

export const StyledTableContainer = styled(TableContainer)(({ theme }) => ({
  borderRadius: '8px',
  border: '1px solid #E0E0E0',
}));

export const StyledTable = styled(Table)(({ theme }) => ({
  minWidth: 650,
}));

// Table Header styling
export const StyledTableHead = styled(TableHead)(({ theme }) => ({
  '& th': {
    backgroundColor: '#5E8E7E', // Theme color from screenshot (greenish)
    color: '#fff',
    fontWeight: 600,
    fontSize: '0.875rem',
  }
}));

export const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(even)': {
    backgroundColor: '#FAFAFA', // Lighter grey for better contrast
  },
  '&:hover': {
    backgroundColor: '#F5F5F5',
  },
}));

export const StyledTableCell = styled(TableCell)(({ theme }) => ({
  fontSize: '0.875rem',
  padding: '16px 16px', // Slightly more padding
  color: '#333',
}));

export const StatusChip = styled(Chip)<{ status?: string }>(({ theme, status }) => {
  let bgcolor = '#E0E0E0';
  let color = '#757575';

  if (status === 'completed') {
    bgcolor = '#E8F5E9';
    color = '#2E7D32';
  } else if (status === 'cancelled') {
    bgcolor = '#FFEBEE';
    color = '#C62828';
  } else if (status === 'upcoming' || status === 'started') {
    bgcolor = '#E3F2FD';
    color = '#1565C0';
  }

  return {
    backgroundColor: bgcolor,
    color: color,
    borderRadius: '4px',
    fontWeight: 500,
    fontSize: '0.75rem',
    height: '24px',
    textTransform: 'capitalize', // Ensure status text is capitalized
  };
});

export const PaginationContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginTop: theme.spacing(2),
  paddingTop: theme.spacing(2),
}));

// Export Button styling
export const ExportButton = styled(Button)(({ theme }) => ({
  textTransform: 'none',
  borderRadius: '6px',
  backgroundColor: '#E6F0EA', // Light greenish-grey
  color: '#4A7A6A', // Darker green text
  fontWeight: 600,
  padding: '6px 16px',
  '&:hover': {
    backgroundColor: '#D9E8DF',
  }
}));

export const HeaderTitle = styled(Typography)(({ theme }) => ({
  fontWeight: 700,
  fontSize: '1.25rem',
  color: '#333',
}));
